import React from "react";
import { Card, CardBody, Form, FormGroup, Modal } from "reactstrap";
import truecaller from "../../../../assets/images/truecaller.png";
import whatsapp from "../../../../assets/images/whatsapp.png";
import gmail from "../../../../assets/images/gmail.png";
import applicant from "../../../../assets/images/applicant.png";
import coapplicant from "../../../../assets/images/coapplicant.png";
import close from "../../../../assets/images/close.png";
import { useCurrentUser } from '../../../../hooks/useCurrentUser';
export default function BasicDetails(props) {
  const {
    applicationDetails,
    isExpanded,
    setIsExpanded,
    handleMobileDetails,
    popUp,
    setpopUp,
    handleCoappMobileDetails,
    setpopUp1,
    popUp1,
  } = props;
  const decode = useCurrentUser();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "30px",
      }}
    >
      <Card
        style={{
          border: "solid",
          borderRadius: "10px",
          borderWidth: "1px",
          borderColor: "#DBDBDB",
          width: "100%",
          height: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ marginTop: "10px" }}>
          <div
            style={{
              marginLeft: "20px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              height: "40px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                style={{ height: "33px", width: "33px" }}
                src={applicant}
                alt="applicant"
              />
              <p
                style={{
                  marginLeft: "20px",
                  fontFamily: "Inter-Medium",
                  color: "#232323",
                  marginTop: "15px",
                  fontWeight: "500",
                }}
              >
                Applicant
              </p>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "10px",
              }}
            >
              {applicationDetails && applicationDetails.profile ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "10px",
                  }}
                >
                  {popUp && (
                    <>
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          zIndex: 999,
                        }}
                      ></div>
                      <Modal
                        style={{
                          width: "500px",

                          top: "30%",
                          borderRadius: "10px",
                        }}
                        isOpen={popUp}
                      >
                        <Form>
                          <FormGroup>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "20px",
                                paddingLeft: "20px",
                              }}
                            >
                              <p
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#D22129",
                                    fontFamily: "Inter-Medium",
                                    fontSize: "20px",
                                    fontWeight: "500",
                                  }}
                                >
                                  Mobile :
                                </span>
                                <span
                                  style={{
                                    fontFamily: "Inter-Medium",
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "black",
                                    marginLeft: "20px",
                                  }}
                                >
                                  {
                                    applicationDetails.profile.userDetails
                                      .mobile
                                  }
                                </span>{" "}
                              </p>
                              <p
                                style={{
                                  marginRight: "20px",
                                  cursor: "pointer",
                                  marginBottom: "30px",
                                }}
                              >
                                <img
                                  onClick={() => setpopUp(!popUp)}
                                  src={close}
                                  alt="close"
                                />
                              </p>
                            </div>
                          </FormGroup>
                        </Form>
                      </Modal>
                    </>
                  )}
                  <img
                    src={truecaller}
                    alt="mobile"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleMobileDetails()}
                  />

                  <a
                    href={`https://wa.me/+91${applicationDetails?.profile?.userDetails?.mobile}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={whatsapp}
                      alt=""
                      style={{ paddingLeft: "15px" }}
                    />
                  </a>
                  <a
                    href={`mailto:${applicationDetails?.profile?.userDetails?.email}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={gmail} alt="" style={{ paddingLeft: "15px" }} />
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div
            style={{
              borderTop: "0.75px solid #DBDBDB",
              margin: "10px 0",
            }}
          ></div>
        </div>
        <div style={{ paddingLeft: "20px" }}>
          <CardBody>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <div style={{ width: "calc(50% - 1em)", margin: "0.5em" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Name
                  </strong>
                  <span
                    onClick={() => setIsExpanded(!isExpanded)}
                    title={
                      applicationDetails?.coapplicantProfile?.userDetails
                        ?.name || ""
                    }
                    style={{
                      whiteSpace: isExpanded ? "normal" : "nowrap",
                      textOverflow: isExpanded ? "unset" : "ellipsis",
                      overflow: isExpanded ? "unset" : "hidden",
                      cursor: isExpanded ? "auto" : "pointer",
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: isExpanded ? "30px" : "30px",
                      display: "block",
                      width: "100%",
                      wordBreak: "break-word",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails?.profile?.userDetails?.name
                      ? applicationDetails?.profile?.userDetails?.name
                          ?.toLowerCase()
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")
                      : "-------"}
                  </span>
                </p>
              </div>
              {decode?.clientId !== "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                <div style={{ width: "calc(50% - 1em)", margin: "0.5em" }}>
                  <p style={{ display: "flex", flexDirection: "column" }}>
                    <strong
                      style={{
                        color: "gray",
                        fontFamily: "Inter-Medium",
                        fontWeight: "400",
                        lineHeight: "20px",
                        fontSize: "15px",
                      }}
                    >
                      Student Name
                    </strong>
                    <span
                      onClick={() => setIsExpanded(!isExpanded)}
                      title={
                        applicationDetails?.coapplicantProfile?.userDetails
                          ?.name || ""
                      }
                      style={{
                        whiteSpace: isExpanded ? "normal" : "nowrap",
                        textOverflow: isExpanded ? "unset" : "ellipsis",
                        overflow: isExpanded ? "unset" : "hidden",
                        cursor: isExpanded ? "auto" : "pointer",
                        textDecoration: "none",
                        color: "#232323",
                        fontSize: "13px",
                        fontFamily: "Inter-Medium",
                        lineHeight: isExpanded ? "30px" : "30px",
                        display: "block",
                        width: "100%",
                        wordBreak: "break-word",
                      }}
                    >
                      {applicationDetails &&
                      applicationDetails?.profile?.userDetails?.studentName
                        ? applicationDetails?.profile?.userDetails?.studentName
                            ?.toLowerCase()
                            .split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1)
                            )
                            .join(" ")
                        : "-------"}
                    </span>
                  </p>
                </div>
              )}
              <div style={{ width: "calc(50% - 1em)", margin: "0.5em" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Employment
                  </strong>
                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails?.profile?.userDetails?.typeOfBusiness
                      ? applicationDetails?.profile?.userDetails?.typeOfBusiness
                      : "-------"}
                  </span>
                </p>
              </div>
              <div style={{ width: "calc(50% - 1em)", margin: "0.5em" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Salary
                  </strong>
                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails
                      ? applicationDetails?.profile?.userDetails?.salary
                      : null}
                  </span>
                </p>
              </div>
              <div style={{ width: "calc(50% - 1em)", margin: "0.5em" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Date Of Birth
                  </strong>
                  <span
                    style={{
                      color: "#232323",
                      fontSize: "15px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails?.profile?.userDetails?.dob
                      ? applicationDetails?.profile?.userDetails?.dob
                      : "-------"}
                  </span>
                </p>
              </div>
              <div style={{ width: "calc(50% - 1em)", margin: "0.5em" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Company Name
                  </strong>
                  <span
                    onClick={() => setIsExpanded(!isExpanded)}
                    title={
                      applicationDetails?.coapplicantProfile?.userDetails
                        ?.name || ""
                    }
                    style={{
                      whiteSpace: isExpanded ? "normal" : "nowrap",
                      textOverflow: isExpanded ? "unset" : "ellipsis",
                      overflow: isExpanded ? "unset" : "hidden",
                      cursor: isExpanded ? "auto" : "pointer",
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: isExpanded ? "30px" : "30px",
                      display: "block",
                      width: "100%",
                      wordBreak: "break-word",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails?.profile?.userDetails?.company
                      ? applicationDetails?.profile?.userDetails?.company
                      : "-------"}
                  </span>
                </p>
              </div>
              <div style={{ width: "calc(50% - 1em)", margin: "0.5em" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Income per month
                  </strong>
                  <span
                    onClick={() => setIsExpanded(!isExpanded)}
                    title={
                      applicationDetails?.coapplicantProfile?.userDetails
                        ?.name || ""
                    }
                    style={{
                      whiteSpace: isExpanded ? "normal" : "nowrap",
                      textOverflow: isExpanded ? "unset" : "ellipsis",
                      overflow: isExpanded ? "unset" : "hidden",
                      cursor: isExpanded ? "auto" : "pointer",
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: isExpanded ? "30px" : "30px",
                      display: "block",
                      width: "100%",
                      wordBreak: "break-word",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails?.profile?.userDetails?.incomePerMonth
                      ? applicationDetails?.profile?.userDetails?.incomePerMonth
                      : "-------"}
                  </span>
                </p>
              </div>
              <div style={{ width: "calc(50% - 1em)", margin: "0.5em" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "10px",
                      fontSize: "15px",
                    }}
                  >
                    Permanent Address
                  </strong>
                  <span
                    onClick={() => setIsExpanded(!isExpanded)}
                    title={
                      applicationDetails?.coapplicantProfile?.userDetails
                        ?.name || ""
                    }
                    style={{
                      whiteSpace: isExpanded ? "normal" : "nowrap",
                      textOverflow: isExpanded ? "unset" : "ellipsis",
                      overflow: isExpanded ? "unset" : "hidden",
                      cursor: isExpanded ? "auto" : "pointer",
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: isExpanded ? "30px" : "30px",
                      wordBreak: "break-word",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails?.profile?.userDetails?.permanentAddress
                      ? applicationDetails?.profile?.userDetails
                          ?.permanentAddress
                      : "-------"}
                  </span>
                </p>
              </div>
              <div style={{ width: "calc(50% - 1em)", margin: "0.5em" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "10px",
                      fontSize: "15px",
                    }}
                  >
                    Current Address
                  </strong>
                  <span
                    onClick={() => setIsExpanded(!isExpanded)}
                    title={
                      applicationDetails?.coapplicantProfile?.userDetails
                        ?.name || ""
                    }
                    style={{
                      whiteSpace: isExpanded ? "normal" : "nowrap",
                      textOverflow: isExpanded ? "unset" : "ellipsis",
                      overflow: isExpanded ? "unset" : "hidden",
                      cursor: isExpanded ? "auto" : "pointer",
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: isExpanded ? "30px" : "30px",
                      wordBreak: "break-word",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails?.profile?.userDetails?.currentAddress
                      ? applicationDetails?.profile?.userDetails?.currentAddress
                      : "-------"}
                  </span>
                </p>
              </div>
            </div>
          </CardBody>
        </div>
      </Card>
      {applicationDetails ? (
        applicationDetails.coapplicantProfile ? (
          <Card
            style={{
              border: "solid",
              borderRadius: "10px",
              borderWidth: "1px",
              borderColor: "#DBDBDB",
              width: "100%",
              height: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ marginTop: "10px" }}>
              <div
                style={{
                  marginLeft: "20px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  height: "40px",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    style={{ height: "33px", width: "33px" }}
                    src={coapplicant}
                    alt="coapplicant"
                  />
                  <p
                    style={{
                      marginLeft: "20px",
                      fontFamily: "Inter-Medium",
                      color: "#232323",
                      marginTop: "15px",
                      fontWeight: "500",
                    }}
                  >
                    Co-Applicant
                  </p>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {applicationDetails &&
                  applicationDetails.coapplicantProfile ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginRight: "10px",
                      }}
                    >
                      {popUp1 && (
                        <>
                          <div
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              zIndex: 999,
                            }}
                          ></div>
                          <Modal
                            style={{
                              width: "500px",

                              top: "30%",
                              borderRadius: "10px",
                            }}
                            isOpen={popUp1}
                          >
                            <Form>
                              <FormGroup>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginTop: "20px",
                                    paddingLeft: "20px",
                                  }}
                                >
                                  <p
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "#D22129",
                                        fontFamily: "Inter-Medium",
                                        fontSize: "20px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Mobile :
                                    </span>
                                    <span
                                      style={{
                                        fontFamily: "Inter-Medium",
                                        fontSize: "20px",
                                        fontWeight: "500",
                                        color: "black",
                                        marginLeft: "20px",
                                      }}
                                    >
                                      {
                                        applicationDetails.coapplicantProfile
                                          .userDetails.mobile
                                      }
                                    </span>{" "}
                                  </p>
                                  <p
                                    style={{
                                      marginRight: "20px",
                                      cursor: "pointer",
                                      marginBottom: "30px",
                                    }}
                                  >
                                    <img
                                      onClick={() => setpopUp1(!popUp1)}
                                      src={close}
                                      alt="close"
                                    />
                                  </p>
                                </div>
                              </FormGroup>
                            </Form>
                          </Modal>
                        </>
                      )}
                      <img
                        src={truecaller}
                        alt="mobile"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleCoappMobileDetails()}
                      />

                      <a
                        href={`https://wa.me/+91${applicationDetails?.coapplicantProfile?.userDetails?.mobile}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={whatsapp}
                          style={{ paddingLeft: "15px" }}
                          alt=""
                        />
                      </a>
                      <a
                        href={`mailto:${applicationDetails?.coapplicantProfile?.userDetails?.email}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={gmail}
                          style={{ paddingLeft: "15px" }}
                          alt=""
                        />
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div
                style={{
                  borderTop: "0.75px solid #DBDBDB",
                  margin: "10px 0",
                }}
              ></div>
            </div>
            <div style={{ paddingLeft: "20px" }}>
              <CardBody>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "calc(50% - 10px)",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        Name
                      </strong>
                      <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        title={
                          applicationDetails?.coapplicantProfile?.userDetails
                            ?.name || ""
                        }
                        style={{
                          whiteSpace: isExpanded ? "normal" : "nowrap",
                          textOverflow: isExpanded ? "unset" : "ellipsis",
                          overflow: isExpanded ? "unset" : "hidden",
                          cursor: isExpanded ? "auto" : "pointer",
                          textDecoration: "none",
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: isExpanded ? "30px" : "30px",
                          display: "block",
                          width: "100%",
                          wordBreak: "break-word",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails?.coapplicantProfile?.userDetails
                          ?.name
                          ? applicationDetails?.coapplicantProfile?.userDetails?.name
                              ?.toLowerCase()
                              .split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1)
                              )
                              .join(" ")
                          : "-------"}
                      </span>
                    </p>
                  </div>

                  {decode?.clientId !==
                    "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                    <div
                      style={{
                        width: "calc(50% - 10px)",
                        marginBottom: "20px",
                      }}
                    >
                      <p
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <strong
                          style={{
                            color: "gray",
                            fontFamily: "Inter-Medium",
                            fontWeight: "400",
                            lineHeight: "20px",
                            fontSize: "15px",
                          }}
                        >
                          Student Name
                        </strong>
                        <span
                          onClick={() => setIsExpanded(!isExpanded)}
                          title={
                            applicationDetails?.coapplicantProfile?.userDetails
                              ?.name || ""
                          }
                          style={{
                            whiteSpace: isExpanded ? "normal" : "nowrap",
                            textOverflow: isExpanded ? "unset" : "ellipsis",
                            overflow: isExpanded ? "unset" : "hidden",
                            cursor: isExpanded ? "auto" : "pointer",
                            textDecoration: "none",
                            color: "#232323",
                            fontSize: "13px",
                            fontFamily: "Inter-Medium",
                            lineHeight: isExpanded ? "30px" : "30px",
                            display: "block",
                            width: "100%",
                            wordBreak: "break-word",
                          }}
                        >
                          {applicationDetails &&
                          applicationDetails?.coapplicantProfile?.userDetails
                            ?.studentName
                            ? applicationDetails?.coapplicantProfile?.userDetails?.studentName
                                ?.toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")
                            : "-------"}
                        </span>
                      </p>
                    </div>
                  )}

                  <div
                    style={{
                      width: "calc(50% - 10px)",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        Employment
                      </strong>
                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile.userDetails
                          .typeOfBusiness
                          ? applicationDetails.coapplicantProfile.userDetails
                              .typeOfBusiness
                          : "-------"}
                      </span>
                    </p>
                  </div>

                  <div
                    style={{
                      width: "calc(50% - 10px)",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        Salary
                      </strong>
                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile.userDetails.salary
                          ? applicationDetails.coapplicantProfile.userDetails
                              .salary
                          : "-------"}
                      </span>
                    </p>
                  </div>

                  <div
                    style={{
                      width: "calc(50% - 10px)",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        Date Of Birth
                      </strong>
                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile.userDetails.dob
                          ? applicationDetails.coapplicantProfile.userDetails
                              .dob
                          : "-------"}
                      </span>
                    </p>
                  </div>

                  <div
                    style={{
                      width: "calc(50% - 10px)",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        Company Name
                      </strong>
                      <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        title={
                          applicationDetails?.coapplicantProfile?.userDetails
                            ?.name || ""
                        }
                        style={{
                          whiteSpace: isExpanded ? "normal" : "nowrap",
                          textOverflow: isExpanded ? "unset" : "ellipsis",
                          overflow: isExpanded ? "unset" : "hidden",
                          cursor: isExpanded ? "auto" : "pointer",
                          textDecoration: "none",
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: isExpanded ? "30px" : "30px",
                          display: "block",
                          width: "100%",
                          wordBreak: "break-word",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile.userDetails
                          .company
                          ? applicationDetails.coapplicantProfile.userDetails
                              .company
                          : "-------"}
                      </span>
                    </p>
                  </div>

                  <div
                    style={{
                      width: "calc(50% - 10px)",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        Permanent Address
                      </strong>
                      <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        title={
                          applicationDetails?.coapplicantProfile?.userDetails
                            ?.name || ""
                        }
                        style={{
                          whiteSpace: isExpanded ? "normal" : "nowrap",
                          textOverflow: isExpanded ? "unset" : "ellipsis",
                          overflow: isExpanded ? "unset" : "hidden",
                          cursor: isExpanded ? "auto" : "pointer",
                          textDecoration: "none",
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: isExpanded ? "30px" : "30px",
                          display: "block",
                          width: "100%",
                          wordBreak: "break-word",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile.userDetails.permanentAddress
                          ? applicationDetails.coapplicantProfile.userDetails
                              .permanentAddress
                          : "-------"}
                      </span>
                    </p>
                  </div>

                  <div
                    style={{
                      width: "calc(50% - 10px)",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        Current Address
                      </strong>
                      <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        title={
                          applicationDetails?.coapplicantProfile?.userDetails
                            ?.name || ""
                        }
                        style={{
                          whiteSpace: isExpanded ? "normal" : "nowrap",
                          textOverflow: isExpanded ? "unset" : "ellipsis",
                          overflow: isExpanded ? "unset" : "hidden",
                          cursor: isExpanded ? "auto" : "pointer",
                          textDecoration: "none",
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: isExpanded ? "30px" : "30px",
                          display: "block",
                          width: "100%",
                          wordBreak: "break-word",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile.userDetails
                          .currentAddress
                          ? applicationDetails.coapplicantProfile.userDetails
                              .currentAddress
                          : "-------"}
                      </span>
                    </p>
                  </div>
                </div>
              </CardBody>
            </div>
          </Card>
        ) : null
      ) : null}
    </div>
  );
}
